export default __webpack_public_path__ + "static/media/Red-Tiger.54e28fcc.png";